import React, { useState, useMemo, useCallback } from 'react';
import { CARD_MODE, GRID_MODE, OPERATORS, TYPES } from '../../../common/list-utils';
import { DefaultPalette } from '@fluentui/react/lib/Styling';
import { ListColumnFilter } from '../../Common/list-entities/ListColumnFilter';
import TimeTaxSupportSystemClient from '../../../system';
import { ICommandBarItemProps, IDropdownOption } from '@fluentui/react';
import { buttonStylesForProjects, defaultCommandBarButtonStyles } from '../../../styles/button-styles';
import { routes } from '../../../common/constants';
import { useNavigate } from 'react-router-dom';
import ViewWrapperWithCommandBar from '../../Layout/ViewWrapperWithCommandBar';
import { useTranslation } from 'react-i18next';
import MessageCourier from '../../../lib/MessageCourier';
import { CostPerHourGridListAje } from './CostPerHourGridListAje';
import useSystemCall from '../../../common/custom-hooks/useSystemCall';
import { IComboBoxOption } from '@fluentui/react';

interface ICostPerHourListAje {
  system: TimeTaxSupportSystemClient;
  changeBlockUI: (state: boolean) => void;
  courier: MessageCourier;
}
export const CostPerHourListAje = (props: ICostPerHourListAje) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState(GRID_MODE);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  const baseUrl = React.useMemo(() => {
    return props.system.getCostPerHourSystem().getBaseUrlForDatagrid();
  }, [props]);

  const onItemClick = (item: any) => {
    // alert('Click!!')
    navigate(`${routes.cost_per_hour_detail_aje}/${item.rcp_id}`);
  };

  const commonContext = useSystemCall(props.system, (system) =>
      system.getActivitySystem().getCommonContext()
  );

  const collaboratorList = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (commonContext) {
      ret = commonContext.colaboradores.map((col) => {
        return {
          key: col.getEmail(),
          text: col.fullName(),
        };
      });
    }
    return ret;
  }, [commonContext]);

  const months: IDropdownOption<any>[] = [
    { key: '1', text: t('Enero') },
    { key: '2', text: t('Febrero') },
    { key: '3', text: t('Marzo') },
    { key: '4', text: t('Abril') },
    { key: '5', text: t('Mayo') },
    { key: '6', text: t('Junio') },
    { key: '7', text: t('Julio') },
    { key: '8', text: t('Agosto') },
    { key: '9', text: t('Septiembre') },
    { key: '10', text: t('Octubre') },
    { key: '11', text: t('Noviembre') },
    { key: '12', text: t('Diciembre') },
  ];

  const quickFilters: ListColumnFilter[] = useMemo(
      () => [
        {
          quick: true,
          name: 'col_email',
          type: TYPES.COMBOBOX,
          placeholder: t('Colaborador'),
          operator: OPERATORS.EQUAL,
          contextForCombobox: collaboratorList || [],
        },
        {
          quick: true,
          name: 'rcp_periodo_mes',
          type: TYPES.COMBOBOX,
          placeholder: t('Mes'),
          operator: OPERATORS.EQUAL,
          contextForCombobox: months,
        },
        {
          quick: true,
          name: 'rcp_periodo_anio',
          type: TYPES.INPUT,
          placeholder: t('Año'),
          operator: OPERATORS.EQUAL,
        },
      ],
      [collaboratorList, months]
  );

  const itemsMenuCalendar = React.useMemo(
      (): ICommandBarItemProps[] => [
        {
          key: 'add',
          text: t('Nuevo'),
          iconProps: { iconName: 'Add', color: DefaultPalette.themeLighterAlt },
          buttonStyles: buttonStylesForProjects,
          onClick: () => navigate(`${routes.cost_per_hour_detail_aje}/new`),
        },
        {
          key: 'excel',
          text: t('Importador Excel'),
          iconProps: { iconName: 'ExcelLogo', color: DefaultPalette.themeLighterAlt },
          buttonStyles: defaultCommandBarButtonStyles,
          onClick: () => navigate(`${routes.cost_per_hour_view_aje}`),
        },
      ],
      [navigate]
  );

  const handleBlockUI = useCallback((state: boolean) => {
    setIsLoading(state);
    props.changeBlockUI(state);
  }, [props]);

  return (
    <>
      {isLoading && <p>Cargando..</p>}
      <div style={{display: isLoading ? 'none': '' }}>
        <ViewWrapperWithCommandBar
          withBorderBottom
          title={""}
          items={itemsMenuCalendar}
          overflowButtonStyles={defaultCommandBarButtonStyles}
          variant="standard"
        >
          <>
            <CostPerHourGridListAje
              changeBlockUI={handleBlockUI}
              baseUrl={baseUrl}
              quickFilters={quickFilters}
              onClickCardMode={() => setMode(CARD_MODE)}
              onClickGridMode={() => setMode(GRID_MODE)}
              mode={mode}
              keyList={"costPerHour"}
              onItemClick={onItemClick}
              courier={props.courier}
            ></CostPerHourGridListAje>
          </>
        </ViewWrapperWithCommandBar>
      </div>
    </>
  );
};
